import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=3b3d0be2&scoped=true&"
import script from "./ContractView.vue?vue&type=script&lang=js&"
export * from "./ContractView.vue?vue&type=script&lang=js&"
import style0 from "./ContractView.vue?vue&type=style&index=0&id=3b3d0be2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d0be2",
  null
  
)

export default component.exports